<form (ngSubmit)="editAgent()" [formGroup]="formAgent">
  <app-toolbar [createdAt]="agent()?.attributes?.createdAt ?? ''" [updatedAt]="agent()?.attributes?.updatedAt ?? ''"
    (edit)="editAgent()" (delete)="deleteAgent()" />

  <p-card>
    <p-tabView>
      <p-tabPanel header="Datos" leftIcon="pi pi-user">
        <form [formGroup]="formAgent">
          <div class="col-12">
            <app-input label="Nombre" placeholder="Nombre" name="name"
              [control]="formUtilities.getControl(formAgent, 'name')" />
          </div>
          <div class="col-12">
            <app-input label="Apellidos" placeholder="Apellidos" name="surname"
              [control]="formUtilities.getControl(formAgent, 'surname')" />
          </div>
          <div class="col-12">
            <app-input label="Email" placeholder="Email" name="email"
              [control]="formUtilities.getControl(formAgent, 'email')" />
          </div>
          <div class="col-12">
            <app-input label="Teléfono" placeholder="Teléfono" name="phone"
              [control]="formUtilities.getControl(formAgent, 'phone')" />
          </div>
          <div class="col-12">
            <app-input label="Teléfono opcional" placeholder="Teléfono opcional" name="phone_optional"
              [control]="formUtilities.getControl(formAgent, 'phone_optional')" />
          </div>
          <div class="col-12">
            <app-input label="Dirección" placeholder="Dirección" name="address"
              [control]="formUtilities.getControl(formAgent, 'address')" />
          </div>
          <div class="col-12">
            <app-input label="Ciudad" placeholder="Ciudad" name="city"
              [control]="formUtilities.getControl(formAgent, 'city')" />
          </div>
          <div class="col-12">
            <app-input label="Provincia" placeholder="Provincia" name="province"
              [control]="formUtilities.getControl(formAgent, 'province')" />
          </div>
          <div class="col-12">
            <app-input label="Código postal" placeholder="Código postal" name="postal_code"
              [control]="formUtilities.getControl(formAgent, 'postal_code')" />
          </div>
          <div class="col-12">
            <app-input label="NIF/CIF" placeholder="NIF/CIF" name="nif_cif"
              [control]="formUtilities.getControl(formAgent, 'nif_cif')" />
          </div>
          <div class="col-12">
            <label for="observation" class="font-semibold">Observación</label>
            <textarea pInputTextarea id="observation" class="w-full text-color-secondary" rows="5" autoResize="true"
              formControlName="observation"></textarea>
          </div>
        </form>
      </p-tabPanel>

      <p-tabPanel header="Personas de contacto" leftIcon="pi pi-users">
        <app-contact-people [contacts]="contacts()" [idAgent]="idAgent()" (contactAdded)="onContactAdded($event)"
          (contactUpdated)="onContactUpdated($event)" (contactDeleted)="onContactDeleted($event)" />
      </p-tabPanel>
    </p-tabView>
  </p-card>
</form>